import './App.css';
import MobileView from './MobileView/MobileView';

function App() {
  return (
    <div className="App">
      <MobileView />
    </div>
  );
}

export default App;
